import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type RightPaneSize = "md";

const rightPanePresetSizes: Record<RightPaneSize, number> = {
  md: 440,
};

type RightPaneRenderFn = (hideRightPane: () => void) => ReactNode;

export interface RightPaneLayoutProps {
  children: ReactNode;
  rightPane?: RightPaneRenderFn;
  rightPaneSize?: RightPaneSize;
  onHideRightPane?: () => void;
  className?: string;
}

export const RightPaneLayout = ({
  children,
  rightPane,
  rightPaneSize = "md",
  onHideRightPane,
  className,
}: RightPaneLayoutProps) => {
  const hasRightPane = !!rightPane;
  const paneWidth = rightPanePresetSizes[rightPaneSize];
  const paneContent = rightPane ? rightPane(() => onHideRightPane?.()) : null;

  return (
    <div className={twMerge("h-full flex overflow-hidden", className)}>
      <div className={"grow min-w-0 h-full overflow-y-auto"}>{children}</div>
      {hasRightPane && (
        <aside
          className={twMerge(
            "h-full shrink-0 overflow-y-auto bg-light border-l border-dark/5",
            "transition-all relative flex flex-col w-[440px]"
          )}
          style={{ width: paneWidth }}
        >
          {paneContent}
        </aside>
      )}
    </div>
  );
};
